<style type="text/css"></style>
<template>
  <div class="new_post">
    <form class="forms-sample" style="border-radius: 10px; border: 1px solid gainsboro" :key="this.$route.params.post">
      <h6 class="sub-title mb-3 color-default font-weight-bold">
        {{ formHeader }}
      </h6>

      <div class="form-group row">
        <!-- title input -->
        <div class="col-md-6">
          <label class="label-form" for="title">Title<span style="color: red">*</span>:</label>
          <input type="text" class="form-control" id="title" v-model="postForm.title" />
        </div>

        <!-- caption input -->
        <div class="col-md-6">
          <label class="label-form" for="htitle">Featured Image <span style="color: red">*</span>:</label>

          <!-- Show the current image if available and not marked for removal -->
          <div class="row" v-if="currentImage && !postForm.remove_image && !this.postForm.caption">
            <div class="col-md-8">
            <span>
              <img :src="currentImage" alt="post caption" height="200" />
<!--              <a href="javascript:void(0);" @click="removeCurrentImage" style="position: absolute; right: 8%; top: 32px">X</a>-->
            </span>
            </div>
          </div>
          <!-- Image preview area -->
          <div class="row" v-if="imagePreview" style="margin-top: 15px; text-align: center;">
            <div class="col-md-8">
              <span>
                <img :src="imagePreview" alt="New Image Preview" height="200" />
              </span>
            </div>
          </div>
          <!-- Hidden input to handle the remove_image flag -->
          <input type="hidden" v-model="postForm.remove_image" />



          <!-- File input for image upload -->
          <div class="form-control" style="padding: 6px; margin-top: 15px;">
            <input type="file" ref="caption" @change="handleCaptionUpload" accept="image/*" />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <!-- select category -->

        <div class="col-md-6">
          <label class="label-form">Category<span style="color: red">*</span>:</label>
          <multiselect :options="selectedCategories" v-model="postForm.category" @search-change="searchCategories"
            @open="getAllPost" label="title" :deselectLabel="null" :selectLabel="null" :selectedLabel="null"
            track-by="id" :max-height="130" :options-limit="20" :allow-empty="false" :internal-search="false">
          </multiselect>
        </div>
        <div class="col-md-6">
          <label class="label-form" for="slug">Slug<span style="color: red">*</span>:</label>
          <input type="text" class="form-control" id="slug" v-model="postForm.new_slug" />
        </div>
        <!-- checkbox to show on admin side -->
        <div class="col-md-6" style="padding-top: 37px">
          <input type="checkbox" v-model="postForm.show_in_admin" />
          <span class="checkmark"></span>
          Show Post on Admin Panel?
        </div>

        <!-- checkbox featured -->
        <div class="col-md-6" style="padding-top: 37px">
          <input type="checkbox" v-model="postForm.featured" />
          <span class="checkmark"></span>
          Make post featured?
        </div>

      </div>
      <div class="form-group row">
        <!-- title input -->

        <div class="col-md-6">
          <label class="label-form" for="meta_title">Meta Title:</label>
          <input type="text" class="form-control" id="meta_title" v-model="postForm.meta_title" />
        </div>
        <div class="col-md-6">
          <label class="label-form" for="meta_description">Meta Description:</label>
          <input type="text" class="form-control" id="meta_description" v-model="postForm.meta_description" />
        </div>
      </div>
      <div class="form-group row">

        <div class="col-md-6">
          <label class="label-form" for="meta_keyword">Meta keyword:</label>
          <input type="text" class="form-control" id="meta_keyword" v-model="postForm.meta_keyword" />
        </div>

        <div class="col-md-12">
          <label class="label-form" for="meta_keyword">Short Description:</label>
          <textarea class="form-control" id="short_description" v-model="postForm.short_description"></textarea>
        </div>
      </div>
      <br />
      <!-- body input -->
      <div class="form-group">
        <label class="label-form" for="describtion">Body<span style="color: red">*</span>:</label>
        <div class="text_editor">
          <tiny-mce-editor :vModelName.sync="postForm.body"></tiny-mce-editor><br />
        </div>
      </div>

      <div class="text-right">
        <button class="btn btn-primary" @click.prevent="save">Submit</button>

      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import "jodit/build/jodit.min.css";
import JoditVue from "jodit-vue";
import TinymceEditor from "../../views/partials/tiny_mce_editor";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    JoditVue,
    "tiny-mce-editor": TinymceEditor,
  },

  data: function () {
    return {
      // softwareOptions: [], 
      selectedCategories: [],
      productId: localStorage.getItem('product_id'),
      //  searchQuery: '',
      //  product: [],
      formHeader: "",
      isLoadingTag: false,
      isLoadingCategory: false,

      postForm: {
        remove_image: false,
      },

      buttons: [
        "bold",
        "strikethrough",
        "underline",
        "italic",
        "|",
        "ul",
        "ol",
        "|",
        "image",
        "table",
        "link",
        "|",
        "outdent",
        "indent",
        "|",
        "align",
        "undo",
        "redo",
        "|",
        "hr",
        "symbol",
        "fullsize",
      ],
      config: {
        uploader: {
          insertImageAsBase64URI: true,
        },
      },
      imagePreview: null,
    };
  },


  computed: {
    product: function () {
      return this.$store.getters["posts/product"];
    },
    post: function () {
      return this.$store.getters["posts/post"];
    },
    categories: function () {
      return this.$store.getters["categories/search"];
    },
    category: function () {
      return this.$store.getters["posts/category"];
    },

    tags: function () {
      return this.$store.getters["tags/search"];
    },
    currentImage() {
      if (typeof this.$route.params.post === "undefined") {
        return "";
      } else {
        // Return the existing image if editing, else return null
        if (!!this.post.caption && this.post.caption != "undefined") {
          if (this.post && this.post.s3_caption) {
            return this.post.s3_caption;
          }
        }
        return null;
      }
    },
  },

  watch: {

    productId(newValue, oldValue) {
      if (this.formHeader == "New Post") {
        this.postForm.category.title = '';
      }

    }


  },
  beforeDestroy() {
    this.stopPolling();
  },
  created: function () {
    this.startPolling();
    // new form
    if (typeof this.$route.params.post === "undefined") {
      this.formHeader = "New Post";
      this.postForm = null;
      this.postForm = {
        new_slug: "",
        title: "",
        body: "",
        category: "",
        tags: [],
        caption: "",
        meta_title: "",
        meta_description: "",
        meta_keyword: "",
        short_description: "",
      };
      return;
    }
    // update from
    this.formHeader = "Update Post";
    this.$store
      .dispatch("posts/getPost", this.$route.params.post)
      .then(() => {
        // Load category options so the selected category displays for Editor/Admin
        return this.$store.dispatch("posts/getProduct");
      })
      .then(() => {
        let product_id = localStorage.getItem("product");

        let post = this.$store.getters["posts/post"];
        this.postForm.new_slug = post.slug.split("-").join(" ");
        this.postForm.slug = post.slug;
        this.postForm.title = post.title;
        this.postForm.id = post.id
        this.postForm.tags = post.tags;
        this.postForm.show_in_admin = post.show_in_admin == "0" ? 0 : 1;
        this.postForm.featured = post.featured == "0" ? 0 : 1;
        // this.postForm.send_email = post.send_email == "0" ? 0 : 1;
        this.postForm.send_email = 0;

        this.selectedCategories = this.product || [];
        let category = null;
        if (product_id == 1) {
          category = post.category;
        } else if (product_id == 2) {
          category = post.stafferCategory;
        } else if (product_id == 3) {
          category = post.equipmateCategory;
        } else if (product_id == 4) {
          category = post.lineniqcategory;
        } else {
          category = post.category;
        }
        // Fallback if product-specific relation is missing
        this.postForm.category = category || post.category || "";

        this.postForm.meta_title = post.meta_title;
        this.postForm.meta_description = post.meta_description;
        this.postForm.meta_keyword = post.meta_keyword;
        this.postForm.short_description = post.short_description;


        if (this.postForm.category) {
          this.$store.commit("categories/SET_CATEGORIES_SEARCH", [this.postForm.category]);
        }



        let body = post.body.replace(
          /posts\/images\/.*?\.png/g,
          (imagePath) => {
            return this.$baseURL + "/storage/" + imagePath;
          }
        );

        // remove the div.body-wrapper
        // if (body.substr(0, 26) === '<div class="body-wrapper">') {
        //   body = body.substring(26, body.lastIndexOf("</asfwfdwqdwqewqewq weqdiv>"));
        // }

        this.postForm.body = body;
      })
      .catch(() => {
        loader.hide(); this.$toast.info(`can't find post '${this.$route.params.post}'!`);
        this.formHeader = "New Post";
        this.$router.push("/posts/new-post");
      });

  },

  methods: {
    getAllPost() {
      this.$store.dispatch("posts/getProduct")
        .then(response => {
          this.selectedCategories = response;
        })
    },

    startPolling() {
      this.pollingInterval = setInterval(() => {
        this.productId = localStorage.getItem('product');
      }, 1000);
    },
    stopPolling() {
      clearInterval(this.pollingInterval);
    },

    searchCategories(query) {
      if (this.product && query) {
        this.selectedCategories = this.product.filter(category =>
          category.title.toLowerCase().includes(query.toLowerCase())
        );
      } else {
        // If no search query, show all products
        this.selectedCategories = this.product;
      }
    },

    deleteImage() {
      axios
        .post("/admin/posts/delete-post-image/" + this.post.slug)
        .then((response) => {
          window.location.reload();
        });
    },

    // search for tags <multiselect>
    searchTags(query) {
      window._.debounce(async function (vm, query) {
        if (query != "") {
          await vm.$store.dispatch("tags/searchTags", query);
        }
      }, 300)(this, query);
    },

    addTag(newTag) {
      const tag = {
        name: newTag,
        id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.postForm.tags.push(tag);
    },

    limitTextTags(count) {
      return `and ${count} other tags`;
    },

    // save form
    // handleCaptionUpload() {
    //   this.postForm.caption = this.$refs.caption.files[0];
    // },
    handleCaptionUpload(event) {
      const file = this.$refs.caption.files[0];
      this.postForm.caption = file;
      if (file && file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreview = e.target.result; // Set the preview for new image
          this.postForm.remove_image = false; // Reset the remove flag if a new image is selected
        };
        reader.readAsDataURL(file); // Read file as data URL
      }
    },
    removeCurrentImage() {
      this.postForm.remove_image = true; // Mark the image for removal
      this.imagePreview = null; // Clear any new preview if present
    },
    save() {
      const isUpdate = typeof this.$route.params.post !== "undefined";
      const hasCategory = this.postForm.category && this.postForm.category.id;
      const hasCaption =
        !!this.postForm.caption ||
        (isUpdate && !!this.currentImage && !this.postForm.remove_image);

      // add the div.body-wrapper when update or create new post
      if (this.postForm.title == "" || !hasCaption || !hasCategory
        || this.postForm.new_slug == "" || this.postForm.body == "") {


        if (this.postForm.body == "") {

          this.$toast.error(`Body field is required.`);

        }
        if (this.postForm.new_slug == "") {
          this.$toast.error(`Slug field is required.`);

        }

        if (!hasCategory) {
          this.$toast.error(`Category field is required.`);

        }
        if (!hasCaption) {
          this.$toast.error(`Featured image is required.`);

        }
        if (this.postForm.title == "") {
          this.$toast.error(`Title field is required.`);

        }
        return false;
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(this.postForm.body, "text/html");
      const bodyContent = doc.body.textContent.trim();

      if (!bodyContent) {
        this.$toast.error(`Body field is required.`);
        return false;
      }

      if (this.postForm.caption && this.postForm.caption != undefined) {
        if (
          this.postForm.caption.type == "image/jpeg" ||
          this.postForm.caption.type == "image/jpg" ||
          this.postForm.caption.type == "image/png" ||
          this.postForm.caption.type == "image/gif"
        ) {
        } else {
          this.$toast.warning(`Please upload image of type ".jpg",".jpeg",".png",".gif".`);
          return false;
        }
      }
      // if (this.postForm.body.substr(0, 26) !== '<div class="body-wrapper">') {
      //   this.postForm.body =
      //     '<div class="body-wrapper">' + this.postForm.body + "</div>";
      // }

      // ==== create post
      if (typeof this.$route.params.post === "undefined") {
        this.createPost(this.postForm);
        return;
      }
      
      let pattern = new RegExp(
        this.$baseURL.replace(/\//g, "\\/") + "/storage/posts/images/.*?.png",
        "g"
      );
      this.postForm.body = this.postForm.body.replace(
        pattern,
        (absolutePath) => {
          let index = absolutePath.indexOf("posts/images/");
          return absolutePath.substr(index);
        }
      );

      this.updatePost(this.postForm);

    },

    // create new post
    createPost(post) {
      let loader = this.$loading.show({
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
      });
      // localStorage.setItem('product', post.software.id);
      this.$store.dispatch("posts/createPost", post)
        .then((postSlug) => {
          // send successful message
          this.$toast.success(`Post has been saved successfully`);
          this.$router.push("/posts");
          loader.hide();
        })
        .catch((error) => {
          let response = error.response;

          // this.$toast.error(response.data.message);

          if (response.data.errors) {
            Object.keys(response.data.errors).forEach((key) => {
              response.data.errors[key].forEach((errorMsg) => {
                this.$toast.error(errorMsg);
              });
            });
          }
          loader.hide();
        });
    },

    // update the given post
    updatePost(post) {
      let loader = this.$loading.show({
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
      });
      this.$store
        .dispatch("posts/updatePost", post)
        .then((postSlug) => {
          if (!postSlug) {
            this.$toast.error(`Post could not be updated.`);
            loader.hide();
            return;
          }
          // send successful message
          this.$toast.success(`Post has been updated successfully`);
          this.$router.push("/posts");
          loader.hide();
        })
        .catch((error) => {
          let response = error && error.response;
          if (response && response.data && response.data.message) {
            this.$toast.error(response.data.message);
          }
          if (response && response.data && response.data.errors) {
            Object.keys(response.data.errors).forEach((key) => {
              response.data.errors[key].forEach((errorMsg) => {
                this.$toast.error(errorMsg);
              });
            });
          } else if (!response) {
            this.$toast.error(`Post could not be updated.`);
          }
          loader.hide();
        });
    },
  },
};
</script>
<style scoped>
.new_post {
  margin-top: -55px !important;
}
</style>